<template>
  <div id="all">
    <div id="tab-5" class="tab-content my-events-box" :class="current ? 'current' : ''">
      <div class="table-box">
        <div class="table" :class="btnCol ? 'my-events-table' : 'past-events-table'">
          <div class="table-head" :style="sort ? 'display: flex;': ''" >
            <div class="col status-col" :class="getFilterClass(1)" @click="filterClick(1)">
              <div class="status-box">
                <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                  <icon-up-down/>
                </icon-base>
                <p class="title-col">Status</p>
              </div>
            </div>
            <div class="col terminal-col" :class="getFilterClass(2)" @click="filterClick(2)">
              <p class="title-col">Terminal</p>
              <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                <icon-up-down/>
              </icon-base>
            </div>
            <div class="col date-col" :class="getFilterClass(3)" @click="filterClick(3)">
              <p class="title-col">Start time (GMT+1)</p>
              <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                <icon-up-down/>
              </icon-base>
            </div>
            <div class="col time-col" :class="getFilterClass(4)" @click="filterClick(4)">
              <p class="title-col">Finish time (GMT+1)</p>
              <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                <icon-up-down/>
              </icon-base>
            </div>
            <div class="col location-col"  :class="getFilterClass(5)" @click="filterClick(5)">
              <p class="title-col">Location</p>
              <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                <icon-up-down/>
              </icon-base>
            </div>

            <div class="col btn-col" v-if="btnCol">

            </div>

          </div>
          <div class="table-body" :class="loading ? 'loading' : ''">

            <div class="row" v-for="(event, index) of events" v-bind:key="index">
              <event-status :status="event.status" :status-title="event.status_text"/>
              <div class="col terminal-col"><p>{{event.name}}</p>
                <p class="terminal-id">{{event.core_module_id}}</p></div>
              <div class="col date-col">
                <div class="col-wrap">
                  <icon-base width="20" height="21" viewBox="0 0 20 21" ><icon-calendar/></icon-base>
                  <p>{{formatDate(event.start_time)}}</p></div>
              </div>
              <div class="col time-col">
                <div class="col-wrap">
                  <icon-base width="20" height="21" viewBox="0 0 20 21" ><icon-calendar/></icon-base>
                  <div class="time-wrap"><p>{{formatDate(event.finish_time)}}</p></div>
                </div>
              </div>
              <div class="col location-col">
                <div class="col-wrap">
                  <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-location/></icon-base>
                  <p>{{event.location}}</p></div>
              </div>
              <div class="col btn-col" v-if="btnCol">
                <a href="" class="extend-btn light-green small-btn" data-title="Extend" @click.prevent="extendEvent(index)">
                  <icon-base width="25" height="25" viewBox="0 0 25 25"><icon-extend/></icon-base>
                  <span>Extend</span>
                </a>
                <a v-if="event.can_delete" href="" class="cancel-btn js-open-popup light-red small-btn" @click.prevent="delEvent(event.id)" data-title="Cancel">
                  <icon-base width="25" height="25" viewBox="0 0 25 25"><icon-cancel/></icon-base>
                  <span>Cancel</span>
                </a>
              </div>
            </div>
          </div>

        </div>

        <!-- <a href="" class="js-show-more">Show more</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapActions} from "vuex"
import Confirm from "./common/Confirm"
import ExtendEvent from "./Client/ExtendEvent"
import IconBase from "./common/IconBase";
import IconUpDown from "./common/icons/IconUpDown";
import IconCalendar from "./common/icons/IconCalendar";
import IconLocation from "./common/icons/IconLocation";
import IconCancel from "./common/icons/IconCancel";
import IconExtend from "./common/icons/IconExtend";
import moment from "moment"
import EventStatus from "./Client/EventStatus";

export default {
    name: 'EventsList',
    components: {
        EventStatus, IconExtend, IconCancel, IconLocation, IconCalendar, IconUpDown, IconBase},
    props: {
        btnCol: {type: Boolean, default: false},
        events: Array,
        // loading: {type: Boolean, default: true},
        current: Number,
        openSort: {type: Boolean, default: false},
        active: {type: Number, default: 1}
    },
    data() {
        return {
          loading: false,
          filterIndex: 0,
          orderBy: true,
          sort: false,
        }
    },
    watch: {
        openSort: function(newVal) {
            this.sort = newVal
        }
    },
    computed: {

    },
    mounted() {
        /*this.loading = true;
        this.loadEvents().then(() => {
            this.loading = false
        })*/
    },
    methods: {
        formatDate(date) {
            return moment(date).format('MMM D YYYY, h:mm a');
        },
        getFilterClass(index) {
            if (index !== this.filterIndex) {
                return '';
            }

            return this.orderBy ? 'filter-up' : 'filter-down'
        },
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapActions('events', [
            'loadEvents',
            'deleteEvent'
        ]),
        delEvent(id) {
            this.setPopupComponent(Confirm);
            this.setPopupData({id: id, func: this.deleteEvent, title: "Are you sure want to cancel this event?", btnText: "CANCEL"});
            this.switchPopup(true);
        },
        extendEvent(index) {
            this.setPopupComponent(ExtendEvent);
            this.setPopupData({event: this.events[index]});
            this.switchPopup(true);
        },
        filterClick(index) {
            let names = [
                '',
                'Status',
                'Terminal',
                'Start time',
                'Finish time',
                'Location',
            ];

            this.sort = false;
            this.$emit('setSort', names[index]);

            if (this.filterIndex === index){
                this.orderBy = !this.orderBy
            } else {
                this.orderBy = true
            }

            let params = [
              '',
              'status',
              'terminal_id',
              'start_time',
              'finish_time',
              'location',

            ];
            this.filterIndex = index;
            let param = !this.orderBy ? '-' + params[this.filterIndex] : params[this.filterIndex];
            params = {
                sort: param,
                active: this.active
            };

            this.loading = true
            this.loadEvents(params).then(() => {
                this.loading = false
            });

        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
